<template>
    <div v-if="book && book.first_episode" class="headline mb-5 pointer-none" :class="{init: init}">
        <div class="d-flex justify-content-center">
            <div class="badge badge-pill badge-success btn btn-headline pointer-auto" @click="show = !show">
                冒頭を読む
            </div>
        </div>
        <div class="d-flex justify-content-center">
            <div v-if="show" class="episode pointer-auto b-light">
                <div class="triangle b-light"></div>
                <div class="d-flex justify-content-center">
                    <h4 v-html="$filters.ruby(book.first_episode.section_name)"></h4>
                </div>
                <div class="d-flex justify-content-center mb-4">
                    <div v-html="$filters.ruby($filters.truncate(book.first_episode.body, 600))"
                        class="mincho"
                        :class="fontClass"></div>
                </div>
                <div class="d-flex justify-content-center">
                    <component
                        :is="isInternal(bookLink) ? 'router-link' : 'a'"
                        :to="isInternal(bookLink) ? bookLink : ''"
                        :href="!isInternal(bookLink) ? bookLink : ''"
                        :target="isInternal(bookLink) ? '_self' : subdomain">
                        続きを読む...
                    </component>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.episode {
    margin-top: 32px;
    position: relative;
    border-radius: .75rem;
    padding: 1rem;
    max-width: 640px;
    color: #222;
    .triangle {
        position: absolute;
        top: 0;
        left: 50%;
        margin-left: -15px;
        margin-top: -20px;
        height: 20px;
        width: 30px;
        clip-path: polygon(50% 0, 100% 100%, 0 100%);
    }
}
.headline {
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
}
.init {
    opacity: 100;
}
.pointer-none {
    pointer-events: none;
}
.pointer-auto {
    pointer-events: auto;
}
.btn-headline {
    font-size: 0.9rem;
}
</style>

<script>
export default {
    props: {
        book: {
            default: null,
        },
        // ドメイン遷移をしない
        directLink: {
            default: false,
        },
        init: {
            default: true,
        }
    },
    data() {
        return {
            show: false,
        }
    },
    methods: {
        isInternal(link) {
            return !link.match(/^(https?:)?\/\//);
        },
    },
    computed: {
        bookLink() {
            let url = "";
            if (!this.directLink) {
                if (this.subdomain + this.$store.state.base_domain !== location.hostname) {
                    // ドメイン判定
                    url = `//${this.subdomain}${this.$store.state.base_domain}`;
                }
            }

            url += `/author/page/${this.book.id}/section/${this.book.first_episode.id}`;
            return url;
        },
        subdomain() {
            let subdomain = "www";
            if (this.book.author && this.book.author.subdomain) {
                subdomain = this.book.author.subdomain.toLowerCase();
            }
            return subdomain;
        },
        fontClass() {
            const cls = {};
            if (this.$store.state.font) {
                cls[this.$store.state.font] = true;
            }
            return cls;
        },
    }
}
</script>